import classNames from 'classnames';
import { formatUsdValue, FLIP_SYMBOL } from '@/shared/utils';
import type TokenAmount from '@/shared/utils/TokenAmount';
import { SkeletonLine } from '../atoms/LoadingSkeleton';
import { TokenLogo } from '../logo/TokenLogo';

interface Props {
  amount: TokenAmount;
  prefix?: string;
  large?: boolean;
  icon?: boolean;
  symbol?: boolean;
  isLoading?: boolean;
  className?: string;
  usdAmount?: string;
  precise?: boolean;
}

export function FlipLabel({
  amount,
  prefix = '',
  icon = true,
  symbol = true,
  isLoading,
  large,
  className,
  usdAmount,
  precise = false,
}: Props): JSX.Element {
  const isLarge = large || usdAmount;
  const showSymbol = symbol && !usdAmount;

  return (
    <div className="flex flex-col">
      <div className={classNames(`flex items-center`, isLarge ? 'space-x-2' : 'space-x-1.5')}>
        {icon && <TokenLogo token="Flip" size={isLarge ? 'medium' : 'small'} />}
        <div
          className={classNames(
            `flex items-end text-white`,
            isLarge ? 'text-20' : 'font-aeonikMono text-14',
            className,
          )}
        >
          {!isLoading ? (
            <span className={className}>
              {prefix}
              {precise ? amount.toFormatted() : amount.toFormatted('numeral')}
            </span>
          ) : (
            <div className="w-12">
              <SkeletonLine className="w-12" />
            </div>
          )}
        </div>
        {showSymbol && <div className="text-12 text-cf-light-2">{FLIP_SYMBOL}</div>}
      </div>
      {usdAmount && Number(usdAmount) !== 0 && (
        <div className="ml-auto text-12 text-cf-light-3">{formatUsdValue(usdAmount, false)}</div>
      )}
    </div>
  );
}
